import { useState, useEffect } from 'react';

function useDebounce(value, delay = 1000) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  const [loading,setLoading] = useState(false);
  const [firstTrack, setFirstTrack]  = useState(true);

  useEffect(() => {
    if(firstTrack){
      setFirstTrack(false);
      return ;
    }
    setLoading(true);
    const handler = setTimeout(() => {
      setDebouncedValue(value);
      setLoading(false);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return [debouncedValue,loading];
}

export default useDebounce;
